import { Pipe, PipeTransform } from '@angular/core';
import { IAdditionalEmails } from '../interfaces';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';

@Pipe({ name: 'isParkerSelectedForUpdate', pure: true })
export class IsParkerSelected implements PipeTransform {
  constructor(private parkerStateService: ParkerStateService) {}

  transform(parkerId: string): boolean {
    let isSelected: boolean = false;
    let ii: number = 0;
    for (ii = 0; ii < this.parkerStateService.parkerUpdateList.length; ii++) {
      if (
        parkerId == this.parkerStateService.parkerUpdateList[ii].parkerId &&
        this.parkerStateService.parkerUpdateList[ii].processed === false
      ) {
        isSelected = true;
      }
    }

    return isSelected;
  }
}
